export { default, BlockPlaceholderProps } from './BlockPlaceholder';
